<script setup lang="ts">
import { UseCursorEnabled } from "~/states/animation";
import { initSmoothScroll, scrollTo } from "~/helpers/functions/smoothScrool";
const { sliderEnabled } = useCustom();
const cursorEnabledRef = UseCursorEnabled();
const route = useRoute();

onMounted(() => {
  initSmoothScroll();
  cursorEnabledRef.value = sliderEnabled;
});
watch(
  () => route.path,
  () => {
    if (route.path !== "/") scrollTo(0);
  }
);
</script>
<template>
  <div
    :class="[
      { 'cursor-enabled': cursorEnabledRef },
      { 'cursor-disabled': !cursorEnabledRef },
    ]"
  >
    <CommonLoading />
    <LayoutCustomCursor v-if="cursorEnabledRef" />
    <LayoutHeader />
    <div id="smooth-content">
      <slot></slot>
    </div>
    <LayoutFooter />
    <LayoutSoundEffect />
  </div>
</template>
<style>
.cursor-enabled {
  cursor: url("../assets/img/custom/defaultCursor.svg"), auto !important;
}
.cursor-disabled .cursor-hover {
  cursor: pointer !important;
}

#smooth-wrapper {
  overflow: hidden;
}

#smooth-content {
  will-change: transform;
}
</style>
